import { render, staticRenderFns } from "./cardManage.vue?vue&type=template&id=08ef6b79&scoped=true"
import script from "./cardManage.vue?vue&type=script&lang=js"
export * from "./cardManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef6b79",
  null
  
)

export default component.exports